const words = (t) => (t || "").trim().split(/\s+/).filter(Boolean).length;

export default function TextSection({ section, value, onChange, integrity }) {
  return (
    <div className="space-y-6" data-testid="free-text-section">
      {section.items.map((item, idx) => {
        const text = value[item.id] || "";
        const w = words(text);
        return (
          <div key={item.id} className="cand-card rounded-lg p-5 sm:p-6" data-testid={`text-item-${item.id}`}>
            <p className="font-data text-xs text-[color:var(--cand-muted)] mb-2">
              Situation {idx + 1}
            </p>
            <p className="text-sm sm:text-base leading-relaxed">{item.prompt}</p>
            <textarea
              className="mt-4 w-full border rounded p-3 text-sm min-h-[180px] leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#EA580C]"
              value={text}
              placeholder="Write what you would actually do, step by step."
              data-testid={`text-answer-${item.id}`}
              onKeyDown={(e) => integrity?.onKeyDown(item.id, e)}
              onPaste={(e) => integrity?.onPaste(item.id, e)}
              onCopy={() => integrity?.onCopy(item.id)}
              onChange={(e) => {
                integrity?.setLength(item.id, e.target.value.length);
                onChange({ ...value, [item.id]: e.target.value });
              }}
            />
            <div className="flex justify-between text-xs mt-2 font-data">
              <span className={w < item.min_words ? "text-[color:var(--cand-accent)]" : "text-[color:var(--cand-muted)]"}>
                {w} words
              </span>
              <span className="text-[color:var(--cand-muted)]" data-testid={`text-minwords-${item.id}`}>
                aim for at least {item.min_words}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
